import React, { memo } from "react";

import SvgIcon from "@mui/material/SvgIcon";

export const ParcelIcon = memo((props) => {
  return (
    <SvgIcon viewBox="0 0 11 12" {...props}>
      <path d="M5.255 1.14667L9.815 3.73333L8.96167 4.19333L4.455 1.60667L5.255 1.14667ZM9.375 5.10667L10.375 4.56667V8.66667L6.875 10.6667V6.45333L7.875 5.91333V7.33333L9.375 6.48667V5.10667ZM7.92167 8.24L7.74833 8.34V9.2L7.92167 9.1V8.24ZM8.215 8.07333L8.04167 8.17333V9.03333L8.215 8.93333V8.07333ZM8.62167 7.84L8.455 7.94V8.8L8.62167 8.7V7.84ZM8.90833 7.68L8.74167 7.77333V8.66667L8.90833 8.57333V7.68ZM9.20167 7.51333L9.02833 7.61333V8.47333L9.20167 8.37333V7.51333ZM9.455 8.22667L9.62167 8.13333V7.27333L9.455 7.36667V8.22667ZM2.895 2.42L1.875 3L6.38167 5.58667L7.38833 5.04L2.895 2.42ZM11.375 3.47333L5.26167 0L0.375 2.76V8.51333L6.50167 12L11.375 9.22667V3.47333ZM5.875 10.4933L1.375 7.92667V3.83333L5.875 6.44667V10.4933Z" />
    </SvgIcon>
  );
});
